module.exports = __webpack_public_path__ + "static/img/credit_score.9b9fd31b.png";